import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { apiService } from '../api/apiclient';
import AccountSelectionModal from './AccountSelection';

const SocialCallback = ({ platform }) => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [status, setStatus] = useState('loading'); // 'loading', 'confirming', 'submitting'
    const [confirmData, setConfirmData] = useState(null);
    const [selectedIds, setSelectedIds] = useState([]);

    useEffect(() => {
        const handleCallback = async () => {
            const code = searchParams.get('code');
            const state = searchParams.get('state');
            if (!code) return navigate('/?error=no_code');

            try {
                const response = await apiService.callbackAuth(platform, code, state);
                if (response.action === "SUCCESS") {
                    navigate('/accounts?status=success');
                } else if (response.action === "NEED_CONFIRM") {
                    setConfirmData(response);
                    setStatus('confirming');
                }
            } catch (err) {
                navigate('/accounts?error=auth_failed');
            }
        };
        handleCallback();
    }, [platform, searchParams, navigate]);

    const handleConfirm = async () => {
        setStatus('submitting');
        try {
            await apiService.confirmAccounts(
                confirmData.tempId,
                selectedIds,
                platform
            );
            navigate('/accounts?status=success');
        } catch (err) {
            setStatus('confirming');
            alert("Submit failed. Please retry later.");
        }
    };

    const toggleSelection = (id) => {
        setSelectedIds(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
    };

    if (status === 'loading') {
        return (
            <div className="flex h-screen items-center justify-center">
                <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-red-600" />
            </div>
        );
    }

    return (
        <AccountSelectionModal
            list={confirmData?.list}
            platform={platform}
            selectedIds={selectedIds}
            onSelect={toggleSelection}
            onConfirm={handleConfirm}
            onCancel={() => navigate('/accounts')}
            loading={status === 'submitting'}
        />
    );
};

export default SocialCallback;